// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMENT_DELETED_BY_ADMIN = "Odpove\u010f bola odstr\u00e1nen\u00e1";
export const COMMENT_DELETED_BY_AUTHOR = "Autor odpove\u010f zmazal";
export const SHOW = "Zobraz";
